import Vue from 'vue'
const Customer = {
  install: (Vue) => {
    const root = new Vue({
      data: {
        customer: {},
        customerData: {
          cards: [],
          documents: [],
          reservations: [],
          visits: [],
          orders: [],
          gdprStates: []
        },
        customerImage: {}
      }
    })
    Vue.prototype.$customer = root
  }
}
Vue.use(Customer)
